import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import * as yup from "yup";
import { normalizeIntensity, shouldValidateSituation } from "./util";
import { intensityMap } from '../const/data_index';

dayjs.extend(customParseFormat);

export const validationCheckEarthquake = (earthquake) => {
    let message = "";

    if (!earthquake?.max_intensity || String(earthquake.max_intensity).length > 4) {
        message = (
            <>
                最大震度を確認してください。 <br />
                また、最大震度は4文字以内で入力してください。
            </>
        )
    }

    const occuredAt = dayjs(earthquake.occured_at);
    if (!earthquake.occured_at || !occuredAt.isValid())
        message = (
            <>
                地震発生日時をご確認の上、有効な日時形式で入力してください。
            </>
        )


    if (!earthquake.epicenter || String(earthquake.epicenter).length > 100) {
        message = (
            <>
                震源地を確認してください。 <br />
                また、震源地は100文字以内で入力してください。
            </>
        )
    }

    return message
}

export const validationCheckCheckResult = (checkResult, facilityDams) => {
    let message = "";
    for (let index = 0; index < checkResult.length; index++) {
        const row = checkResult[index];
        if (facilityDams.includes(row.facility_uuid) && (!row?.inspections_name || String(row.inspections_name).length > 50)) {
            message = (
                <>
                    {row.facility_name}の気象台発表震度観測点を確認してください。 <br />
                    また、気象台発表震度観測点は50文字以内で入力してください。
                </>
            )
            return message
        }

        if (facilityDams.includes(row.facility_uuid) && (!row?.note)) {
            message = (
                <>
                    備考を確認の上、テンプレートのままの場合は入力してください。
                </>
            )
            return message
        }

        if (!row.intensity || String(row.intensity).length > 4) {
            message = (
                <>
                    {row.facility_name}の震度を確認してください。 <br />
                    また、震度は4文字以内で入力してください。
                </>
            )
            return message
        } else {
            const normalizedIntensity = normalizeIntensity(String(row.intensity));
            const isValidFormat = Object.keys(intensityMap).includes(normalizedIntensity);
            if (!isValidFormat) {
                message = (
                    <>
                        正しい震度形式で入力してください。<br />
                        （例：震度なし、震度４、震度５弱、震度６強）
                    </>
                )
                return message
            }
        }

        if (row.has_anomary === 2 && (!row.anomaly_facility_name || String(row.anomaly_facility_name).length > 40)) {
            message = (
                <>
                    {row.facility_name}の異常有設備名を確認してください。 <br />
                    また、異常有設備名は40文字以内で入力してください。
                </>
            )
            return message
        }

        if (row.has_anomary === 2) {
            // 必須・文字数チェック
            if (!row.situation || row.situation.split('\n').some(line => line.trim().length > 80)) {
                message = (
                    <>
                        {row.facility_name}の状況及び臨時点検実施状況等を確認してください。 <br />
                        また、状況及び臨時点検実施状況等は1行80文字以内で入力してください。
                    </>
                )
                return message
            }
        }

        if (shouldValidateSituation(row.facility_uuid, row.intensity, facilityDams)) {
            // 80文字チェック
            if (!row.situation || row.situation.split('\n').some(line => line.trim().length > 80)) {
                message = (
                    <>
                        {row.facility_name}の状況及び臨時点検実施状況等を確認してください。 <br />
                        また、状況及び臨時点検実施状況等は1行80文字以内で入力してください。
                    </>
                )
                return message
            }
        }
    }
    return message
}

export const validationCheckCheckSummary = (checkSummary) => {
    let message = "";

    if (!checkSummary.inspector || String(checkSummary.inspector).length > 50) {
        message = (
            <>
                点検者情報をご確認の上、未入力の場合は入力してください。 <br />
                また、点検者情報は50文字以内で入力してください。
            </>
        )
    }

    if (!checkSummary.reason || String(checkSummary.reason).length > 50) {
        message = (
            <>
                点検要因をご確認の上、未入力の場合は入力してください。 <br />
                また、点検要因は50文字以内で入力してください。
            </>
        )
    }

    const previousAt = dayjs(checkSummary.previous_at)
    if (!previousAt.isValid())
        message = (
            <>
                前回点検年月日をご確認の上、未入力の場合は入力してください。
            </>
        )

    const inspectionDate = dayjs(checkSummary.inspection_date)
    if (!inspectionDate.isValid())
        message = (
            <>
                点検年月日をご確認の上、未入力の場合は入力してください。
            </>
        )

    if (!checkSummary.start_time) {
        // 時刻が無い場合はNG
        message = (
            <>
                開始時刻をご確認の上、未入力の場合は入力してください。
            </>
        )
    }
    if (!checkSummary.end_time) {
        // 時刻が無い場合はNG
        message = (
            <>
                終了時刻をご確認の上、未入力の場合は入力してください。
            </>
        )
    }

    if (!checkSummary.intensity || String(checkSummary.intensity).length > 4) {
        message = (
            <>
                震度情報を確認してください。 <br />
                また、震度は4文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_body_top_crack && (!checkSummary.is_body_top_crack_note || String(checkSummary.is_body_top_crack_note).length > 30)) {
        message = (
            <>
                天端設備のクラックの状況(目視等)を確認してください。 <br />
                また、天端設備のクラックの状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_body_top_facility && (!checkSummary.is_body_top_facility_note || String(checkSummary.is_body_top_facility_note).length > 30)) {
        message = (
            <>
                天端設備の付属設備の状況(目視等)を確認してください。 <br />
                また、天端設備の付属設備の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_body_surface_crack && (!checkSummary.is_body_surface_crack_note || String(checkSummary.is_body_surface_crack_note).length > 30)) {
        message = (
            <>
                上下流面のクラックの状況(目視等)を確認してください。 <br />
                また、上下流面のクラックの状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_body_surface_leak && (!checkSummary.is_body_surface_leak_note || String(checkSummary.is_body_surface_leak_note).length > 30)) {
        message = (
            <>
                上下流面の漏水の状況(目視等)を確認してください。 <br />
                また、上下流面の漏水の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.dam_body_other && (!checkSummary.dam_body_other_note || String(checkSummary.dam_body_other_note).length > 30)) {
        message = (
            <>
                ダム本体のその他の状況(目視等)を確認してください。 <br />
                また、ダム本体のその他の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_reservoir_slope_landslide && (!checkSummary.is_reservoir_slope_landslide_note || String(checkSummary.is_reservoir_slope_landslide_note).length > 30)) {
        message = (
            <>
                貯水池法面の地すべりの状況(目視等)を確認してください。 <br />
                また、貯水池法面の地すべりの状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.reservoir_other && (!checkSummary.reservoir_other_note || String(checkSummary.reservoir_other_note).length > 30)) {
        message = (
            <>
                貯水池及び取付部周辺のその他の状況(目視等)を確認してください。 <br />
                また、貯水池及び取付部周辺のその他の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_gate_crack && (!checkSummary.is_gate_crack_note || String(checkSummary.is_gate_crack_note).length > 30)) {
        message = (
            <>
                ゲート周辺のクラックの状況(目視等)を確認してください。 <br />
                また、ゲート周辺のクラックの状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_gate_leak && (!checkSummary.is_gate_leak_note || String(checkSummary.is_gate_leak_note).length > 30)) {
        message = (
            <>
                ゲート周辺の漏水の状況(目視等)を確認してください。 <br />
                また、ゲート周辺の漏水の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_gate_equipment_anomaly && (!checkSummary.is_gate_equipment_anomaly_note || String(checkSummary.is_gate_equipment_anomaly_note).length > 30)) {
        message = (
            <>
                機器の異常の状況(目視等)を確認してください。 <br />
                また、機器の異常の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.gate_other && (!checkSummary.gate_other_note || String(checkSummary.gate_other_note).length > 30)) {
        message = (
            <>
                放流設備のその他の状況(目視等)を確認してください。 <br />
                また、放流設備のその他の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_communication_equipment_anomaly && (!checkSummary.is_communication_equipment_anomaly_note || String(checkSummary.is_communication_equipment_anomaly_note).length > 30)) {
        message = (
            <>
                通信設備の設備点検の状況(目視等)を確認してください。 <br />
                また、通信設備の設備点検の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_observation_equipment_anomaly && (!checkSummary.is_observation_equipment_anomaly_note || String(checkSummary.is_observation_equipment_anomaly_note).length > 30)) {
        message = (
            <>
                観測設備の設備点検の状況(目視等)を確認してください。 <br />
                また、観測設備の設備点検の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_alarm_equipment_anomaly && (!checkSummary.is_alarm_equipment_anomaly_note || String(checkSummary.is_alarm_equipment_anomaly_note).length > 30)) {
        message = (
            <>
                警報設備の設備点検の状況(目視等)を確認してください。 <br />
                また、警報設備の設備点検の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_backup_power_anomaly && (!checkSummary.is_backup_power_anomaly_note || String(checkSummary.is_backup_power_anomaly_note).length > 30)) {
        message = (
            <>
                予備電源の設備点検の状況(目視等)を確認してください。 <br />
                また、予備電源の設備点検の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.is_other_equipment_anomaly && (!checkSummary.is_other_equipment_anomaly_note || String(checkSummary.is_other_equipment_anomaly_note).length > 30)) {
        message = (
            <>
                通信警報のその他の設備点検の状況(目視等)を確認してください。 <br />
                また、通信警報のその他の設備点検の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    if (checkSummary.inspection_detail_result && (!checkSummary.inspection_detail_result_note || String(checkSummary.inspection_detail_result_note).length > 30)) {
        message = (
            <>
                詳細な外視点検結果の状況(目視等)を確認してください。 <br />
                また、詳細な外視点検結果の状況(目視等)は30文字以内で入力してください。
            </>
        )
    }

    return message
}

export const validationSchemaCheckReult = yup.object().shape({
    checkResults: yup.array().of(
        yup.object().shape({
            inspections_name: yup
                .string()
                .nullable()
                .max(50, "最大50文字です"),
            gal_top_x: yup
                .number()
                .nullable()
                .typeError("数値を入力してください")
                .test(
                    "桁数チェック",
                    "整数最大3桁、小数最大2桁",
                    (value) => value === null || /^\d{1,3}(\.\d{1,2})?$/.test(value)
                ),
            gal_top_y: yup
                .number()
                .nullable()
                .typeError("数値を入力してください")
                .test(
                    "桁数チェック",
                    "整数最大3桁、小数最大2桁",
                    (value) => value === null || /^\d{1,3}(\.\d{1,2})?$/.test(value)
                ),
            gal_top_z: yup
                .number()
                .nullable()
                .typeError("数値を入力してください")
                .test(
                    "桁数チェック",
                    "整数最大3桁、小数最大2桁",
                    (value) => value === null || /^\d{1,3}(\.\d{1,2})?$/.test(value)
                ),
            gal_base_x: yup
                .number()
                .nullable()
                .typeError("数値を入力してください")
                .test(
                    "桁数チェック",
                    "整数最大3桁、小数最大2桁",
                    (value) => value === null || /^\d{1,3}(\.\d{1,2})?$/.test(value)
                ),
            gal_base_y: yup
                .number()
                .nullable()
                .typeError("数値を入力してください")
                .test(
                    "桁数チェック",
                    "整数最大3桁、小数最大2桁",
                    (value) => value === null || /^\d{1,3}(\.\d{1,2})?$/.test(value)
                ),
            gal_base_z: yup
                .number()
                .nullable()
                .typeError("数値を入力してください")
                .test(
                    "桁数チェック",
                    "整数最大3桁、小数最大2桁",
                    (value) => value === null || /^\d{1,3}(\.\d{1,2})?$/.test(value)
                ),
            anomaly_facility_name: yup
                .string()
                .when("has_anomary", {
                    is: 2,  // 異常ありの値
                    then: (schema) => schema.required("異常有設備名は必ず入力してください。").max(40, "最大40文字です"),
                    otherwise: (schema) => schema.nullable(),
                }),
            facility_uuid: yup.string().required(),
            situation: yup
                .string()
                .nullable()
                .test(
                    "line-length",
                    "1行あたり80文字以内で入力してください。",
                    (value) => {
                        if (!value) return true;
                        const lines = value.replace(/\r\n/g, "\n").split("\n");
                        return lines.every((line) => line.trim().length <= 80);
                    }
                )
                .when("$facilityDams", (facilityDams, schema) => {
                    return schema.test(
                        "situation-format",
                        "必須項目です。状況を入力してください。",
                        function (value) {
                            const { facility_uuid, intensity } = this.parent;

                            if (shouldValidateSituation(facility_uuid, intensity, facilityDams)) {
                                if (!value || !value.trim()) {
                                    return this.createError({
                                        message: "必須項目です。状況を入力してください。"
                                    });
                                }
                            }
                            return true;
                        }
                    );
                })
                .when("has_anomary", {
                    is: 2,  // 異常ありの値
                    then: (schema) => schema.required("状況及び臨時点検実施状況等は必ず入力してください。"),
                    otherwise: (schema) => schema.nullable(),
                }),
            intensity: yup
                .string()
                .required("必ず入力してください。")
                .test('valid-intensity', '正しい震度形式で入力してください（例：震度なし、震度４、震度５弱）', function (value) {
                    if (!value) return false;

                    const normalizedValue = normalizeIntensity(value);
                    return Object.keys(intensityMap).includes(normalizedValue);
                }),
            inspections_name: yup
                .string()
                .required("必ず入力してください。")
                .max(50, "最大50文字です"),
            note: yup
                .string()
                .required('備考を必ず入力してください')
        }),
    )
});


export const validationSchemaEarthquake = yup.object().shape({
    earthquakes: yup.object().shape({
        max_intensity: yup
            .string()
            .required("必ず入力してください。")
            .max(4, "最大4文字です"),
        epicenter: yup
            .string()
            .required("必ず入力してください。")
            .max(100, "最大100文字です"),
    })
});


export const validationSchemaCheckSumary = yup.object().shape({
    checkSummarys: yup.object().shape({
        reason: yup
            .string()
            .required("必ず入力してください。")
            .max(50, "最大50文字です"),
        inspector: yup
            .string()
            .required("必ず入力してください。")
            .max(50, "最大50文字です"),
        intensity: yup
            .string()
            .required("必ず入力してください。")
            .test('valid-intensity', '正しい震度形式で入力してください（例：震度４、震度５弱）', function (value) {
                if (!value) return false;

                const normalizedValue = normalizeIntensity(value);
                return Object.keys(intensityMap).includes(normalizedValue);
            }),
        is_body_top_crack_note: yup
            .string()
            .when('is_body_top_crack', {
                is: (is_body_top_crack) => is_body_top_crack === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_body_top_facility_note: yup
            .string()
            .when('is_body_top_facility', {
                is: (is_body_top_facility) => is_body_top_facility === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_body_surface_crack_note: yup
            .string()
            .when('is_body_surface_crack', {
                is: (is_body_surface_crack) => is_body_surface_crack === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_body_surface_leak_note: yup
            .string()
            .when('is_body_surface_leak', {
                is: (is_body_surface_leak) => is_body_surface_leak === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        dam_body_other_note: yup
            .string()
            .when('dam_body_other', {
                is: (dam_body_other) => dam_body_other === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_reservoir_slope_landslide_note: yup
            .string()
            .when('is_reservoir_slope_landslide', {
                is: (is_reservoir_slope_landslide) => is_reservoir_slope_landslide === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        reservoir_other_note: yup
            .string()
            .when('reservoir_other', {
                is: (reservoir_other) => reservoir_other === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_gate_crack_note: yup
            .string()
            .when('is_gate_crack', {
                is: (is_gate_crack) => is_gate_crack === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_gate_leak_note: yup
            .string()
            .when('is_gate_leak', {
                is: (is_gate_leak) => is_gate_leak === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_gate_equipment_anomaly_note: yup
            .string()
            .when('is_gate_equipment_anomaly', {
                is: (is_gate_equipment_anomaly) => is_gate_equipment_anomaly === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        gate_other_note: yup
            .string()
            .when('gate_other', {
                is: (gate_other) => gate_other === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_communication_equipment_anomaly_note: yup
            .string()
            .when('is_communication_equipment_anomaly', {
                is: (is_communication_equipment_anomaly) => is_communication_equipment_anomaly === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_observation_equipment_anomaly_note: yup
            .string()
            .when('is_observation_equipment_anomaly', {
                is: (is_observation_equipment_anomaly) => is_observation_equipment_anomaly === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_alarm_equipment_anomaly_note: yup
            .string()
            .when('is_alarm_equipment_anomaly', {
                is: (is_alarm_equipment_anomaly) => is_alarm_equipment_anomaly === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_backup_power_anomaly_note: yup
            .string()
            .when('is_backup_power_anomaly', {
                is: (is_backup_power_anomaly) => is_backup_power_anomaly === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        is_other_equipment_anomaly_note: yup
            .string()
            .when('is_other_equipment_anomaly', {
                is: (is_other_equipment_anomaly) => is_other_equipment_anomaly === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
        inspection_detail_result_note: yup
            .string()
            .when('inspection_detail_result', {
                is: (inspection_detail_result) => inspection_detail_result === true,  // is_body_top_crack が false の場合
                then: (schema) => schema.required('必ず入力してください。').max(30, '最大30文字です'),  // false の場合は必須と文字数制限を適用
                otherwise: (schema) => schema.nullable(),  // true の場合は nullable を使って、値が空でもエラーにならない
            }),
    })
});

export const validationSchemaUpdateUserInfo = (users = [], currentUserId = null) => yup.object().shape({
    updateUserInfo: yup.object().shape({
        tel: yup
            .string()
            .required("電話番号は必須項目です。")
            .matches(/^0\d{1,4}-?\d{1,4}-?\d{4}$/, "電話番号の形式で入力してください。"),
        email: yup
            .string()
            .required("メールアドレスは必須項目です。")
            .email("メールアドレスの形式で入力してください。")
            .test(
                "unique-email",
                "このメールアドレスは既に登録されています。",
                function (value) {
                    if (!value) return true;
                    // 自分自身のメールアドレスは重複チェック対象外
                    return !users.some(u => u.email === value && u.uuid !== currentUserId);
                }
            ),
        password: yup
            .string()
            .nullable()
            .notRequired()
            .test(
                "password-validation",
                "パスワードは8文字以上で英大文字・小文字、数字を含む必要があります。",
                function (value) {
                    if (!value) return true; // 空ならスキップ
                    const hasMinLength = value.length >= 8;
                    const hasUpper = /[A-Z]/.test(value);
                    const hasLower = /[a-z]/.test(value);
                    const hasNumber = /[0-9]/.test(value);
                    return hasMinLength && hasUpper && hasLower && hasNumber;
                }
            ),
        confirmPassword: yup
            .string()
            .nullable()
            .notRequired()
            .test(
                "confirm-password-match",
                "パスワードと入力内容が異なります。",
                function (value) {
                    const { password } = this.parent;
                    if (!password) return true; // パスワード未入力なら一致チェック不要
                    return value === password;
                }
            ),
    }),
});

// 連絡先会社登録のバリデーション
export const validationSchemaRegistPartnerCompany = () => yup.object().shape({
    registPartnerCompany: yup.object().shape({
        name: yup.string().required("連絡先会社名は必須項目です。"),
        facilities: yup.array().min(1, "担当発電所は必須項目です。")
    })
});

// 連絡先会社更新のバリデーション
export const validationSchemaEditPartnerCompany = () => yup.object().shape({
    editingPartnerCompany: yup.object().shape({
        name: yup.string().required("連絡先会社名は必須項目です。"),
        facilities: yup.array().min(1, "担当発電所は必須項目です。")
    })
});

// 連絡先担当者登録のバリデーション
export const validationSchemaRegistPartnerCompanyPerson = (partners = []) =>
    yup.object().shape({
        registPartnerCompanyPerson: yup.object().shape({
            companies: yup.string().required("所属会社は必須項目です。"),
            name: yup.string().required("氏名は必須項目です。"),
            tel: yup.string()
                .required("電話番号は必須項目です。")
                .matches(/^[0-9]*$/, "電話番号は数字のみで入力してください。"),
            is_main_person: yup.boolean().test(
                "unique-main",
                "同一会社で主担当は1人のみです。",
                function (value) {
                    if (!value) return true; // 主担当でない場合はチェック不要
                    const selectedCompany = this.parent.companies;

                    return !partners.some(
                        (p) => p.partner_company_uuid === selectedCompany && p.is_main_person === 1
                    );
                }
            )
        })
    });

// 連絡先担当者更新のバリデーション
export const validationSchemaEditPartnerCompanyPerson = yup.object().shape({
    editPartnerCompanyPerson: yup.object().shape({
        partner_company_name: yup.string().required("所属会社は必須項目です。"),
        person_name: yup.string().required("氏名は必須項目です。"),
        tel: yup.string()
            .required("電話番号は必須項目です。")
            .matches(/^[0-9]*$/, "電話番号は数字のみで入力してください。"),
        is_main_person: yup.boolean().test(
            "unique-main",
            "同一会社で主担当は1人のみです。",
            function (value) {
                const partners = this.options.context?.partners;
                if (!partners) return true;       // データ未取得時はバリデーション通す
                if (!value) return true;          // 主担当でない場合も通す

                const selectedCompanyUuid = this.parent.partner_company_uuid; // 選択中の会社UUID
                const currentUuid = this.parent.uuid;

                // 同じ会社で既に主担当がいないかチェック
                return !partners.some(
                    (p) =>
                        p.partner_company_uuid === selectedCompanyUuid &&
                        p.is_main_person === 1 &&
                        p.uuid !== currentUuid
                );
            }
        )
    })
});

// 送付先登録のバリデーション
export const validationSchemaRegistRecipient = () => yup.object().shape({
    registRecipient: yup.object().shape({
        name: yup.string().required("氏名は必須項目です。"),
        department_name: yup.string().required("部署名、肩書は必須項目です。"),
        email: yup
            .string()
            .required("メールアドレスは必須項目です。")
            .email("メールアドレスの形式で入力してください。"),
        send_category: yup.string().required("送付先カテゴリは必須項目です。")
    })
});

// 送付先更新のバリデーション
export const validationSchemaEditRecipient = yup.object().shape({
    editRecipient: yup.object().shape({
        name: yup.string().required("氏名は必須項目です。"),
        department_name: yup.string().required("部署名、肩書は必須項目です。"),
        email: yup
            .string()
            .required("メールアドレスは必須項目です。")
            .email("メールアドレスの形式で入力してください。")
    })
});

// 業務登録のバリデーション
export const validationSchemaRegistWork = () => yup.object().shape({
    registWork: yup.object().shape({
        name: yup.string().required("業務名は必須項目です。")
    })
});

// 業務更新のバリデーション
export const validationSchemaEditWork = yup.object().shape({
    editWork: yup.object().shape({
        name: yup.string().required("業務名は必須項目です。")
    })
});

// 部署名更新のバリデーション
export const validationSchemaEditDepartment = yup.object().shape({
    editDepartment: yup.object().shape({
        name: yup.string().required("部署名は必須項目です。")
    })
});

// ユーザー登録のバリデーション
export const validationSchemaRegistUser = (users = []) => yup.object().shape({
    registUser: yup.object().shape({
        name: yup.string().required("氏名は必須項目です。"),
        tel: yup.string()
            .required("電話番号は必須項目です。")
            .matches(/^[0-9]*$/, "電話番号は数字のみで入力してください。"),
        email: yup
            .string()
            .required("メールアドレスは必須項目です。")
            .email("メールアドレスの形式で入力してください。")
            .test(
                "unique-email",
                "このメールアドレスは既に登録されています。",
                function (value) {
                    if (!value) return true;
                    return !users.some(u => u.email === value);
                }
            ),
        password: yup
            .string()
            .required("パスワードは必須項目です。")
            .test(
                "password-validation",
                "パスワードは8文字以上で英大文字・小文字、数字を含む必要があります。",
                function (value) {
                    if (!value) return true; // 空ならスキップ
                    const hasMinLength = value.length >= 8;
                    const hasUpper = /[A-Z]/.test(value);
                    const hasLower = /[a-z]/.test(value);
                    const hasNumber = /[0-9]/.test(value);
                    return hasMinLength && hasUpper && hasLower && hasNumber;
                }
            ),
        password_confirm: yup
            .string()
            .required("パスワードは必須項目です。")
            .test(
                "password-confirm-match",
                "パスワードと入力内容が異なります。",
                function (value) {
                    const { password } = this.parent;
                    if (!password) return true; // パスワード未入力なら一致チェック不要
                    return value === password;
                }
            ),
        department: yup.string().required("所属は必須項目です。"),
        role: yup.string().required("権限は必須項目です。")
    })
});

// ユーザー更新のバリデーション
export const validationSchemaEditUser = yup.object().shape({
    editUser: yup.object().shape({
        name: yup.string().required("氏名は必須項目です。"),
        tel: yup.string()
            .required("電話番号は必須項目です。")
            .matches(/^[0-9]*$/, "電話番号は数字のみで入力してください。"),
        email: yup
            .string()
            .required("メールアドレスは必須項目です。")
            .email("メールアドレスの形式で入力してください。")
            .test(
                "unique-email-edit",
                "このメールアドレスは既に登録されています。",
                function (value) {
                    const users = this.options.context?.users;
                    const currentUuid = this.parent.uuid;
                    if (!value || !users) return true;
                    return !users.some(u => u.email === value && u.uuid !== currentUuid);
                }
            ),
        password: yup
            .string()
            .nullable()
            .notRequired()
            .test(
                "password-validation",
                "パスワードは8文字以上で英大文字・小文字、数字を含む必要があります。",
                function (value) {
                    if (!value) return true; // 空ならスキップ
                    const hasMinLength = value.length >= 8;
                    const hasUpper = /[A-Z]/.test(value);
                    const hasLower = /[a-z]/.test(value);
                    const hasNumber = /[0-9]/.test(value);
                    return hasMinLength && hasUpper && hasLower && hasNumber;
                }
            ),

        password_confirm: yup
            .string()
            .nullable()
            .notRequired()
            .test(
                "password-confirm-match",
                "パスワードと入力内容が異なります。",
                function (value) {
                    const { password } = this.parent;
                    if (!password) return true; // パスワード未入力なら一致チェック不要
                    return value === password;
                }
            ),
        department: yup.string().required("所属は必須項目です。"),
        role: yup.string().required("権限は必須項目です。")
    })
});